import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function mapScriptStatus(status: string) {
  switch (status) {
    case 'PENDING':
      return 'AVAILABLE'
    case 'PROCESSING':
      return 'NOT DUE'
    case 'SUSPENDED':
      return 'DEFERRED'
    default:
      return status
  }
}
